import { define } from 'wicked-elements'
import Monogrid from 'monogrid'

define('[data-component~="monogrid"]', {
  init () {
    this.grid = new Monogrid(this.element)
  },
  connected () {
    this.grid.observe()
  },
  disconnected () {
    this.grid.unobserve()
  }
})